import React, { useState } from "react"

import dayjs from "dayjs";

import {
    validationSchema as _validationSchema,
    initialValues as _initialValues,

    initialRowValues as _initialRowValues,
    containerSizes as _containerSizes,
    containerTypes as _containerTypes,

    customInjectionProps as _customInjectionProps,
    customInjectionFields as _customInjectionFields
} from "../../schema/repositories/containerSchema";

// import {
//     useInjectionProps,
//     getSchedulerRequestIds,
//     getAppendSchedulerProps,
//     propTypes as injectionPropTypes,
//     propRefs as injectionPropRefs,
//     propFieldTypes as injectionPropFieldTypes,
//     targetTypes as injectionPropTargetTypes,
// } from "../../../../hooks/api/useInjectionProps"

import {
    useInjectionFields,
    getUpdateFieldValuesPayload,
    scopeTypes as injectionFieldScopeTypes,
} from "../../../../hooks/api/useInjectionFields"

import {
    useSchedulers,
    schedulerConfigs,
    schedulerTypes,
    targetTypes as schedulerTargetTypes,
    schedulerModules,
    schedulerRefs,
    schedulerTargets
} from "../../../../hooks/api/useSchedulers"

import { useRepositories, repositoryTypes, targetTypes as repositoryTargetTypes } from "../../../../hooks/api/useRepositories";

import {
    productInjectionProps,
    useProduct
} from "./useProduct"

import { getInjectionDataType } from "../../utils/injectionSelection";

export const validationSchema = _validationSchema
export const initialValues = _initialValues

export const initialRowValues = _initialRowValues
export const containerTypes = _containerTypes
export const containerSizes = _containerSizes

export const containerInjectionProps = _customInjectionProps
export const containerInjectionFields = _customInjectionFields


export function useContainer({
    jwtToken: _jwtToken,
    routeType: _routeType
}) {

    const [routeType, setRouteType] = useState(_routeType)

    const { list, get, create, remove, update, filterOperatorTypes } = useRepositories({
        repositoryType: repositoryTypes.container,
        targetType: repositoryTargetTypes.container
    });

    const {
        create: createSchedulerRequest
    } = useSchedulers({ schedulerType: schedulerTypes.schedulerRequest, targetType: schedulerTargetTypes.schedulerRequest })

    // const {
    //     create: createInjectionProps
    // } = useInjectionProps({
    //     propType: injectionPropTypes.repository.container.id,
    //     targetType: injectionPropTargetTypes.repository.id
    // })

    const { updateFieldValues } = useInjectionFields({
        scopeType: injectionFieldScopeTypes.repository.id
    });

    const { listProducts } = useProduct({ routeType })

    // list containers
    const listContainers = async ({
        props,
        containerIds: _containerIds = [],
        containerIdFrom = 0,
        containerIdTo = 0,
        dataTypes: _dataTypes = [`${getInjectionDataType('container')}`]
    }) => {

        props.dataTypes = _dataTypes

        let filterValues = [
        ]

        if (_containerIds.length > 0) {
            filterValues = [...filterValues, ...[
                {
                    name: `id`,
                    operator: filterOperatorTypes.anyOf,
                    value: JSON.stringify(_containerIds),
                },
            ]]
        }

        if (containerIdFrom > 0) {
            filterValues = [...filterValues, ...[
                {
                    name: `id`,
                    operator: filterOperatorTypes.moreThanEq,
                    value: containerIdFrom
                },
            ]]
        }

        if (containerIdTo > 0) {
            filterValues = [...filterValues, ...[
                {
                    name: `id`,
                    operator: filterOperatorTypes.lessThanEq,
                    value: containerIdTo
                },
            ]]
        }

        if (props?.filterValue) {
            props.filterValue = [...props.filterValue, ...filterValues]
        } else {
            props.filterValue = filterValues
        }

        const result = await list(props)

        let data = result?.data?.repositories ? result.data.repositories : []

        return {
            data,
            // count: result?.data?.nofilter_total
            count: result?.data?.total
        }

    }

    // get container
    const getContainer = async ({ id, dataTypesArray = [`${getInjectionDataType('container')}`] }) => {

        const result = await get({ id, dataTypesArray })

        let data = result?.data ? result.data : {}

        return data

    }

    // done
    // add container
    const addContainer = async ({
        containerSize: _containerSize = '',
        containerType: _containerType = '',
        repository: _repository = {
            repoNumber: '',
            numberAlternative: '',
            repoDate: '',
            remark: '',
        },
        props: _props = {
            locationId: '',
            toLocationId: '',
            numberSeal: '',
            numberMarking: '',
            loadDate: '',
            etaDate: '',
            supervisor: '',
            shipper: '',
            customAgent: ''
        },
    }) => {

        let data = {
            repository: {
                repo_number: _repository?.repoNumber,
                number_alternative: _repository?.numberAlternative,
                repo_date: dayjs(_repository?.repoDate).format("YYYY-MM-DD"),
                remark: _repository?.remark,
            },
            props: {
                location_id: _props?.locationId,
                to_location_id: _props?.toLocationId,
                number_seal: _props?.numberSeal,
                number_marking: _props?.numberMarking,
                load_date: dayjs(_props?.loadDate).format("YYYY-MM-DD"),
                eta_date: _props?.etaDate,
                supervisor: _props?.supervisor,
                shipper: _props?.shipper,
                custom_agent: _props?.customAgent,
            },
        }

        const response = await create({
            data,
            skipSchedulerRequestSubmit: true
        });

        // getting the scheduler responses (If any)
        // let schedulerRequestIds = getSchedulerRequestIds(response?.data)
        // console.log('response', schedulerRequestIds)

        let containerId = response?.data.repository.id

        // let injectionProps = [
        //     {
        //         props_module: injectionPropTypes.repository.container.id,
        //         props_ref: injectionPropTargetTypes.repository.id,
        //         ref_id: {
        //             [injectionPropRefs.repository.container]: containerId // user.id
        //         },
        //         props_key: containerInjectionProps.containerSize.submitKey,
        //         props_field: containerInjectionProps.containerSize.propFieldId,
        //         [containerInjectionProps.containerSize.propFieldName]: _containerSize,
        //         is_multiple: containerInjectionProps.containerSize.propIsMultiple,
        //         ...getAppendSchedulerProps(schedulerRequestIds, [`${getInjectionDataType('container')}`])
        //     },
        //     {
        //         props_module: injectionPropTypes.repository.container.id,
        //         props_ref: injectionPropTargetTypes.repository.id,
        //         ref_id: {
        //             [injectionPropRefs.repository.container]: containerId
        //         },
        //         props_key: containerInjectionProps.containerType.submitKey,
        //         props_field: containerInjectionProps.containerType.propFieldId,
        //         [containerInjectionProps.containerType.propFieldName]: _containerType,
        //         is_multiple: containerInjectionProps.containerType.propIsMultiple,
        //         ...getAppendSchedulerProps(schedulerRequestIds, [`${getInjectionDataType('container')}`])
        //     },
        // ];

        // console.log('injectionProps', injectionProps)

        let injectionFields = [
            {
                refId: `${containerId}`,
                ref: `${containerInjectionFields.containerSize.ref}`,
                module: `${containerInjectionFields.containerSize.module}`,
                key: `${containerInjectionFields.containerSize.submitKey}`,
                value: `${_containerSize}`,
            },
            {
                refId: `${containerId}`,
                ref: `${containerInjectionFields.containerType.ref}`,
                module: `${containerInjectionFields.containerType.module}`,
                key: `${containerInjectionFields.containerType.submitKey}`,
                value: `${_containerType}`,
            },
        ];

        // console.log('injectionFields', injectionFields)

        // let dataInjectionProps = {
        //     injection_props: injectionProps
        // }

        // injection props
        // const responseInjectionProps = await createInjectionProps({ data: dataInjectionProps })

        // injection fields
        const responseInjectionFields = await updateFieldValues({ data: getUpdateFieldValuesPayload({ items: injectionFields }) })

        // console.log("Injection Props", responseInjectionProps)
        // console.log("Injection Fields", responseInjectionFields)

        const newData = await getContainer({ id: containerId })

        // console.log('newDatanewDatanewDatanewData', newData)

        const {
            repository
        } = newData;

        let dataSchedulerRequest = {
            scheduler_request: {
                source_id: containerId,
                target: schedulerTargets.request.repository,
                module: schedulerModules.request.repository.container,
                request_ref: schedulerRefs.request.repository.container,
                integration_id: schedulerConfigs?.schedulerIntegrationIds[0],
                destination_id: repository[containerInjectionFields.sourceContainerRemId.retrieveKey],
                action: 'create',
                source_data:
                    JSON.stringify(newData)
            }
        }

        // console.log('create load update container SR : ', JSON.stringify(dataSchedulerRequest))

        // create scheduler request
        await createSchedulerRequest({ data: dataSchedulerRequest, schedulerType: schedulerTypes.schedulerRequest, targetType: schedulerTargetTypes.schedulerRequest })


        return response
    }

    // done
    // update container
    const updateContainer = async ({
        containerId: _containerId = '',
        containerSize: _containerSize = '',
        containerType: _containerType = '',
        repository: _repository = {
            repoNumber: '',
            numberAlternative: '',
            repoDate: '',
            remark: '',
        },
        props: _props = {
            locationId: '',
            toLocationId: '',
            numberSeal: '',
            numberMarking: '',
            loadDate: '',
            etaDate: '',
            supervisor: '',
            shipper: '',
            customAgent: ''
        },
    }) => {

        let data = {
            repository: {
                repo_number: _repository?.repoNumber,
                number_alternative: _repository?.numberAlternative,
                repo_date: dayjs(_repository?.repoDate).format("YYYY-MM-DD"),
                remark: _repository?.remark,
            },
            props: {
                location_id: _props?.locationId,
                to_location_id: _props?.toLocationId,
                number_seal: _props?.numberSeal,
                number_marking: _props?.numberMarking,
                load_date: dayjs(_props?.loadDate).format("YYYY-MM-DD"),
                eta_date: "",
                supervisor: _props?.supervisor,
                shipper: _props?.shipper,
                custom_agent: _props?.customAgent,
            },
            // items:
        }

        const response = await update({
            id: _containerId,
            data,
            skipSchedulerRequestSubmit: true
        });

        // getting the scheduler responses (If any)
        // let schedulerRequestIds = getSchedulerRequestIds(response?.data)
        // console.log('response', schedulerRequestIds)

        // injection props
        // let injectionProps = [
        //     {
        //         props_module: injectionPropTypes.repository.container.id,
        //         props_ref: injectionPropTargetTypes.repository.id,
        //         ref_id: {
        //             [injectionPropRefs.repository.container]: _containerId
        //         },
        //         props_key: containerInjectionProps.containerSize.submitKey,
        //         props_field: containerInjectionProps.containerSize.propFieldId,
        //         [containerInjectionProps.containerSize.propFieldName]: _containerSize,
        //         is_multiple: 0,
        //         ...getAppendSchedulerProps(schedulerRequestIds, [`${getInjectionDataType('container')}`])
        //     },
        //     {
        //         props_module: injectionPropTypes.repository.container.id,
        //         props_ref: injectionPropTargetTypes.repository.id,
        //         ref_id: {
        //             [injectionPropRefs.repository.container]: _containerId
        //         },
        //         props_key: containerInjectionProps.containerType.submitKey,
        //         props_field: containerInjectionProps.containerType.propFieldId,
        //         [containerInjectionProps.containerType.propFieldName]: _containerType,
        //         is_multiple: 0,
        //         ...getAppendSchedulerProps(schedulerRequestIds, [`${getInjectionDataType('container')}`])
        //     },
        // ];

        // injection fields
        let injectionFields = [
            {
                refId: `${_containerId}`,
                ref: `${containerInjectionFields.containerSize.ref}`,
                module: `${containerInjectionFields.containerSize.module}`,
                key: `${containerInjectionFields.containerSize.submitKey}`,
                value: `${_containerSize}`,

            },
            {
                refId: `${_containerId}`,
                ref: `${containerInjectionFields.containerType.ref}`,
                module: `${containerInjectionFields.containerType.module}`,
                key: `${containerInjectionFields.containerType.submitKey}`,
                value: `${_containerType}`,

            },
        ];


        // let dataInjectionProps = {
        //     injection_props: injectionProps
        // }

        // // injection props
        // const responseInjectionProps = await createInjectionProps({ data: dataInjectionProps })

        // injection fields
        const responseInjectionFields = await updateFieldValues({ data: getUpdateFieldValuesPayload({ items: injectionFields }) })

        const newData = await getContainer({ id: _containerId })

        const {
            repository
        } = newData;

        let dataSchedulerRequest = {
            scheduler_request: {
                source_id: _containerId,
                target: schedulerTargets.request.repository,
                module: schedulerModules.request.repository.container,
                request_ref: schedulerRefs.request.repository.container,
                integration_id: schedulerConfigs?.schedulerIntegrationIds[0],
                destination_id: repository[containerInjectionFields.sourceContainerRemId.retrieveKey],
                action: 'update',
                source_data:
                    JSON.stringify(newData)
            }
        }

        // console.log('create load update container SR : ', JSON.stringify(dataSchedulerRequest))

        // create scheduler request
        await createSchedulerRequest({ data: dataSchedulerRequest, schedulerType: schedulerTypes.schedulerRequest, targetType: schedulerTargetTypes.schedulerRequest })

        return response

    }

    // delete containers
    const deleteContainers = async ({
        ids: _ids = []
    }) => {

        // have to check the container have assigned products - if have block
        const props = {
            limit: -1,
            skip: 0,
            filterValue: [],
            sortInfo: {
                id: "id",
                dir: 0
            },
        }

        const { data } = await listProducts({
            props,
            loadContainerIds: _ids
        })


        let allRelatedProducts = data

        // console.log('allRelatedProducts', allRelatedProducts)

        let canProceed = true
        // let msg = ''

        // loop for all containers to check if selected have products assigned
        _ids.forEach(i => {
            let checkExists = allRelatedProducts.filter(i2 => i2[productInjectionProps.loadContainerId.retrieveKey] === i)

            if (checkExists.length > 0) {
                canProceed = false
                // msg = `${msg}}`
            }
        })

        if (canProceed === false) {
            // promptMessage(false, t(''))
            // setSystemLoading(false)
            // return false
            throw Error(`thereAreSomeProductsAlreadyLoadedToTheContainers`)
        }

        let result = await remove({ ids: _ids })

        return result

    }

    return {
        filterOperatorTypes,
        listContainers,
        getContainer,
        addContainer,
        updateContainer,
        deleteContainers
    }
}